/**
 * CapabilityLine — A single capability permission row (plugins, activity, discovery).
 *
 * Shows: [icon] [text] [detail tags]
 */
import { Monitor, FileText, Users, Zap, Boxes } from 'lucide-react';

const KIND_ICONS = {
  plugins: Monitor,
  activity: FileText,
  discovery: Users,
  automations: Zap,
  sub_entity: Boxes,
};

export default function CapabilityLine({ kind, text, detailTags }) {
  const Icon = KIND_ICONS[kind];

  return (
    <div className="perm-cap-line">
      {Icon && <Icon size={14} className="perm-cap-line__icon" />}
      <div className="perm-cap-line__body">
        <div className="perm-cap-line__text">{text}</div>
        {detailTags?.length > 0 && (
          <div className="perm-cap-line__tags">
            {detailTags.map((tag, j) => (
              <code key={j} className="perm-field-tag">{tag}</code>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
